import { FunctionComponent } from 'react';
import { match } from 'react-router-dom';

import { renderRoutes } from 'scenes/Report/Report.helper';

import {
  SalesPerSubscriberLiftByDate,
  SalesPerSubscriberOverallLift,
  FrequencyLiftByDate,
  FrequencyOverallLift,
  AovLiftByDate,
  AovOverallLift,
} from '.';

type Props = {
  match: match;
  whitelistReports?: string[];
};

const routes = (match: match) => [
  { path: `${match.url}/frequencyLiftByDate`, component: FrequencyLiftByDate },
  {
    path: `${match.url}/salesPerSubscriberLiftByDate`,
    component: SalesPerSubscriberLiftByDate,
  },
  {
    path: `${match.url}/salesPerSubscriberOverallLift`,
    component: SalesPerSubscriberOverallLift,
  },
  {
    path: `${match.url}/frequencyOverallLift`,
    component: FrequencyOverallLift,
  },
  {
    path: `${match.url}/aovLiftByDate`,
    component: AovLiftByDate,
  },
  {
    path: `${match.url}/aovOverallLift`,
    component: AovOverallLift,
  },
];

const ControlGroupReportsRoutes: FunctionComponent<Props> = ({
  match,
  whitelistReports,
}) => renderRoutes(routes(match), whitelistReports);

export default ControlGroupReportsRoutes;
